import React from 'react';

import classNames from 'classnames';

import './balance-informer.scss';

interface BalanceInformerProps {
  sum: string;
  title: string;
  sm?: boolean;
}

const BalanceInformer: React.FC<BalanceInformerProps> = ({
  sum,
  title,
  sm,
}) => (
  <div
    className={classNames('sum-informer', {
      'sum-informer--sm-bold': sm,
    })}
  >
    <div className="sum-informer__title">{title}:</div>
    <div className="sum-informer__body">
      <div className="sum-informer__sum">
        {sum} <span>₽</span>
      </div>
    </div>
  </div>
);

export default BalanceInformer;
